// https://splidejs.com/
import Splide from '@splidejs/splide';

const productSlider = {
	
	ui: {
		scrollTicking:false
	},

	init: function() {
		this.bindUI();
		this.bindEvents();

		this.initSlider();
	},

	bindUI: function() {
		this.ui.$productSlider = $('.js-productSlider');
		this.ui.$productSliderSplide = this.ui.$productSlider.find(".js-productSlider__splide");
		this.ui.$productSliderScrollHandle = $('.js-productSlider__scrollHandle');
	},

	bindEvents: function() {
	},
	

	initSlider: function() {
		this.ui.$productSliderSplide.each(function(){
			let $this = $(this);
			let $slides = $this.find(".js-productSlider__slide");
			let nb_slides = $slides.length;
			let midleSlideIndex = Math.floor(nb_slides/2);

			var splide = new Splide( $this[0], {
				type   : 'slide',
				autoWidth: true,
				pagination: false,
				focus  : 'center',
				// drag   : 'free'
			});
			splide.mount();
			if (window.matchMedia("(min-width: 420px)").matches) {
				setTimeout(()=>{
					splide.go(midleSlideIndex);
				},500);
			}else{
				// fix weird decal on preprod
				setTimeout(()=>{
					splide.go(0);
				},500);
			}
		});
	},
};

module.exports = productSlider;